import { FC } from 'react'

import styles from './BsketProductCardSkeleton.module.scss'

import Skeleton from 'components/atom/Skeleton'

const BasketProductCardSkeleton: FC = () => (
  <div className={styles.wrapper}>
      <div className={styles.wrapper_container} >
          <Skeleton className={styles.wrapper_container_image} width='100%' height='380px' />
          <div className={styles.wrapper_container_details}>
              <div style={{display: "flex", width: '100%', justifyContent:'space-between'}}>
              <Skeleton className={styles.wrapper_container_details_title} width='70%' height='32px' />
                  <Skeleton className={styles.wrapper_container_details_price} width='50px' height='24px' />
              </div>
              <Skeleton className={styles.wrapper_container_details_subtitle} width='30%' height='23px' />
              <Skeleton className={styles.wrapper_container_details_subtitle} width='40%' height='28px' />

          </div>
      </div>

  </div>
)

export default BasketProductCardSkeleton
